module.exports = __webpack_public_path__ + "static/Fire04-5e20773febd27bcd84aee2e5993feb5e.png";